import React from "react";
import ContactList from "./components/ContactTable/ContactList";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";

const Rolodex = () => {
  return (
    <NavHeightAdjust>
      <ContactList />
    </NavHeightAdjust>
  );
};

export default Rolodex;
